<div class="card">
    <div class="card-header">
        <h3 class="card-title"><i class="fa-globe-americas fas"></i> Sites assigned to user <span class="badge badge-primary badge-top mr-2"><small>{{assignedSites}} of {{this.sites.length}}</small></span></h3>
    </div>
    <div class="card-body">
            <mat-progress-bar mode="indeterminate" *ngIf="submitted"></mat-progress-bar>
            <ul class="nav">
<!--                 <li class="nav-item">
                    <div class="search-container">
                        <i class="fa fa-search search-icon"></i>
                        <input class="form-control form-control-sm search-box" type="text"
                            (input)="tableFilter($event)" placeholder="Filter">
                    </div>
                </li> -->
                <li class="nav-item">
                    <app-select-check-all [select]="sites_list" [text]="'Select all sites'"></app-select-check-all>
                </li>
            </ul>
            
            <perfect-scrollbar class="user-site-perfect-scrollbar" >
                <mat-selection-list #sites_list class="mr-3" (selectionChange)="sites_list_MatSelectionListChange($event)">
                    <mat-list-option *ngFor="let elem of sitelist" class="item-option" [value]="elem.value.id" [selected]="elem.selected" >
                        {{uidescription(elem)}}
                    </mat-list-option>
                </mat-selection-list>                
            </perfect-scrollbar>
            <div class="clearfix"></div>
    </div>
</div>